import { Bar } from 'react-chartjs-2';
import { Loader } from '../../../../components/loading/Loader';

export const DiorDataDashboardGraphRacksPerProcess = ({ isLoading = false, rackData = [] }) => {

  const labels = rackData.map(({ type }) =>
    type === 'GA000' ? 'Unscanned' : type === 'GA999' ? 'Rework' : type
  );

  const data = {
    labels,
    datasets: [
      {
        label: 'Racks',
        data: rackData.map(({ num_of_racks }) => num_of_racks),
        backgroundColor: rackData.map(({ isHighlighted }) =>
          isHighlighted ? '#F28725' : '#666666'
        ),
        borderRadius: 6,
        barPercentage: 0.8,
        categoryPercentage: 0.8,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: ({ raw }) => `${raw} racks`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        border: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
  };

  return (
    <div className="h-[400px] max-h-[400px] overflow-y-auto mt-4">
      {isLoading ?
        <Loader category="transparent"/> :
        <div
          style={{
            height: `${Math.max(300, rackData.length * 35)}px`
          }}
        >
          <Bar data={data} options={options} />
        </div>
      }
    </div>
  );
};